import React, { useState } from "react";
import { Box } from "@mui/material";
import AdminLogin from "../admin/AdminLogin";
import AdminDashboard from "../admin/AdminDashboard";
import { isLoggedIn } from "../admin/adminApi";

export default function AdminPage() {
  const [authenticated, setAuthenticated] = useState(isLoggedIn());

  if (!authenticated) {
    return <AdminLogin onLogin={() => setAuthenticated(true)} />;
  }

  return <AdminDashboard onLogout={() => setAuthenticated(false)} />;
}
